var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99978 7.94085L12.7121 4.22852L13.7728 5.28917L10.0604 9.0015L13.7728 12.7138L12.7121 13.7744L8.99978 10.0622L5.28747 13.7744L4.22681 12.7138L7.93913 9.0015L4.22681 5.28917L5.28747 4.22852L8.99978 7.94085Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClean);
export default __webpack_public_path__ + "static/media/icon_clean.dfbe78f63b1fb1dd64cbca66a259d120.svg";
export { ForwardRef as ReactComponent };